import { ErrorBoundary } from 'react-error-boundary';
import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../components';
import JobsListContextProvider from '../../../context/jobsListContext';
import { default as PermissionContextProvider } from '../../../context/PermissionContext/PermissionContext';
import { CampaignEmails } from '../../../features/emailSettings/components/campaignEmails';
import { JobCampaignEmailLayout } from '../../../features/emailSettings/components/layout/jobCampaignLayout';
import { useAtsAccess, AtsAccess } from '../../../hooks/useAtsAccess';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import { Loader } from '../../conversationWidget/components/Loader';
import Assign from '../assign';
import BulkJobsAssign from '../assign/bulkJobsAssign';
import Listing from '../listing';
import { PostNew, EditJob } from '../post';
import CloneJob from '../post/components/CloneJob';
import Publish from '../publish';
import CareerBuilderAccount from '../publish/components/premiumJobBoards/careerBuilderAccount/CareerBuilderAccount';
import { CwJobsPostingAccount } from '../publish/components/premiumJobBoards/cwJobsPostingAccount';
import DiceAccount from '../publish/components/premiumJobBoards/diceAccount/DiceAccount';
import { MonsterAccount } from '../publish/components/premiumJobBoards/monsterAccount';
import TechFetchAccount from '../publish/components/premiumJobBoards/techFetchAccount/TechFetchAccount';

export const JobsRoutes = () => {
  const isViewJobsList = useAtsAccess(AtsAccess.JOBS_LISTING);
  const isCreateJobAllowed = useAtsAccess(AtsAccess.CREATE_NEW_JOBS);
  return (
    <Routes>
      <Route
        path="new"
        element={
          <RouteWithTitle title="Post Job - Wisestep">
            <RouteGuard feature="JS_INTERNAL_JOB_POSTING">
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <JobsListContextProvider>
                  {isCreateJobAllowed ? <PostNew /> : <AccessControl />}
                </JobsListContextProvider>
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path=":jobId/edit"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <JobsListContextProvider>
                <EditJob />
              </JobsListContextProvider>
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/clone"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <JobsListContextProvider>
                <CloneJob />
              </JobsListContextProvider>
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/assign"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <JobsListContextProvider>
                <Assign />
              </JobsListContextProvider>
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <Publish />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish/dice"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <DiceAccount />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish/techFetch"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <TechFetchAccount />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish/careerBuilder"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <CareerBuilderAccount />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish/monster"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <MonsterAccount />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path=":jobId/publish/CWJobs"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <CwJobsPostingAccount />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/"
        element={
          <RouteWithTitle title="Jobs">
            <RouteGuard>
              <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                <JobsListContextProvider>
                  <PermissionContextProvider>
                    {isViewJobsList == undefined ? (
                      <Loader />
                    ) : isViewJobsList ? (
                      <Listing />
                    ) : (
                      <AccessControl />
                    )}
                  </PermissionContextProvider>
                </JobsListContextProvider>
              </ErrorBoundary>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
      <Route
        path="/bulk-assign"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <BulkJobsAssign />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/email-campaigns"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <CampaignEmails />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
      <Route
        path="/job-email-campaign"
        element={
          <RouteGuard>
            <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
              <JobCampaignEmailLayout />
            </ErrorBoundary>
          </RouteGuard>
        }
      />
    </Routes>
  );
};
